type DaemonTriggerResourceLoadingInput = {
  pathname: string;
  isShelllessRoute: boolean;
  hasRunnerRequestParam: boolean;
  isDaemonTriggerResourceRequested: boolean;
};

export const shouldLoadDaemonTriggerResources = ({
  pathname,
  isShelllessRoute,
  hasRunnerRequestParam,
  isDaemonTriggerResourceRequested,
}: DaemonTriggerResourceLoadingInput) => {
  const isHomeRoute = pathname === '/home';
  const isDaemonTriggerRoute = pathname === '/daemon-triggers';
  const isNotificationRoute = pathname === '/notifications';
  const isSidebarShellRoute = !isHomeRoute && !isShelllessRoute;

  return (
    isSidebarShellRoute ||
    isDaemonTriggerRoute ||
    isNotificationRoute ||
    hasRunnerRequestParam ||
    isDaemonTriggerResourceRequested
  );
};
